import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Button } from '@/Components/ui';
;
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast, { Toaster } from 'react-hot-toast';
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_USER_VOUCHER_GIFTS, deleteUserVoucherGiftItem, getDataFromUrl } from "../../../api";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
function printDiv(elid) {
    var divContents = document.getElementById(elid).innerHTML;
    var a = window.open("", "", "height=700, width=500");
    a.document.write("<html>");
    a.document.write('<body><table class="custom-header-css table">');
    a.document.write(divContents);
    // console.log(divContents)
    a.document.write("</table></body></html>");
    a.document.close();
    a.print();
}
const UserVoucherGiftList = () => {
    const navigate = useNavigate();
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        //["id", "name","sender","phone_num","recipient","recipient_phone_num","expire_date","voucher_state","voucher_id","gift_state"]
        //   {
        //     Header: 'ID',
        //     accessor: 'id',
        //     id: 'id',
        //   },
        {
            Header: "교환권ID",
            accessor: "voucher_id",
            id: "voucher_id",
        },
        {
            Header: "상품명",
            accessor: "name",
            id: "name",
        },
        {
            Header: "만기일",
            accessor: "expire_date",
            id: "expire_date",
        },
        {
            Header: "선물일",
            accessor: "send_date",
            id: "send_date",
            Cell: (cellProps) => {
                return <span>{moment(cellProps.row.original["send_date"]).format("YYYY-MM-DD HH:mm")}</span>;
            },
        },
        {
            Header: "보낸이",
            accessor: "phone_num",
            id: "phone_num",
        },
        {
            Header: "받는이",
            accessor: "recipient_phone_num",
            id: "recipient_phone_num",
        },
        {
            Header: "선물상태",
            accessor: "gift_state",
            id: "gift_state",
        },
        {
            Header: "상태",
            accessor: "voucher_state",
            id: "voucher_state",
            // Cell: (cellProps) => {
            //   const selref = useRef(null);
            //   useEffect(() => {
            //     if(selref) {
            //       selref.current.setValue(selectUserVoucherState.find((val) => {
            //         return cellProps.row.original['reserv_state'].valueOf() === val.value.valueOf()
            //       }), "deselect-option")
            //     }
            //   },[cellProps])
            //   return <>
            //   <Select ref={selref}
            //   className="mb-0"
            //   defaultValue={selectUserVoucherState.find((val) => {
            //     return cellProps.row.original['reserv_state'].valueOf() === val.value.valueOf()
            //   })}
            //   onChange={(val) => {
            //     if(cellProps.row.original['reserv_state'].valueOf() === val.value.valueOf()) return
            //     changeUserVoucherState(cellProps.row.original.reserv_id, val.value).then((data) => {
            //       console.log("changeUserVoucherState", data)
            //       toast.success(`예약상태를 변경하였습니다!\n : ${cellProps.row.original['reserv_state']}=>${val.value}`, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //         theme: "light",
            //       });
            //     });
            //   }}
            //   options={selectUserVoucherState}
            //   id={"choices-single-" + cellProps.row.original.id}
            // ></Select>
            // </>
            // }
        },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
              <div className="remove">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        onClickDelete(cellProps.row.original.id);
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], []);
    // const [modal, setModal] = React.useState(false);
    const [data, setData] = React.useState([]);
    // 10/23 대표 승인: "만료됨"은 기본 숨김, "만료 포함 보기"로 볼 수 있음
    const [showExpired, setShowExpired] = React.useState(false);
    const expiredQuery = React.useMemo(() => ({ hide_expired: showExpired ? "" : "1" }), [showExpired]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_USER_VOUCHER_GIFTS}/?hide_expired=1`)
                .then((data) => {
                console.log("getDataFromUrl", data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => {
                console.log(e);
            });
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    // const clearSelectedOptions = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   const checkall = document.getElementById("checkBoxAll");
    //   ele.forEach((element) => {
    //     element.checked = false;
    //   })
    //   checkall.checked = false;
    //   // setFocusState(-1);
    // }
    // const changeCheckedRecords = () => {
    //   const ele = document.querySelectorAll(".customerCheckBox:checked");
    //   let checked = []
    //   try {
    //     ele.forEach((element) => {
    //       let tmpArr = data.filter((voucher) => (voucher.id).toString() === element.value.toString());
    //       let obj = tmpArr[0];
    //       checked.push(obj);
    //     })
    //   } catch (error) {
    //     console.log(error)
    //   }
    //   // console.log("changeCheckedRecords", checked)
    //   setCheckedRecords(checked);
    // }
    const deleteRecords = async () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        if (ele.length === 0) {
            await dialogService.handleAlert("삭제할 항목이 없습니다.");
            return;
        }
        ele.forEach((element) => {
            console.log("user voucher id:", element.value);
            deleteUserVoucherGiftItem(element.value)
                .then((data) => {
                console.log("deleteUserVoucherGiftItem:", data);
            })
                .catch((e) => {
                console.log(e);
            });
            element.checked = false;
        });
    };
    const onClickDelete = (order) => {
        setCheckedRecords([order]);
        setDeleteModal(true);
    };
    const handleDeleteOrder = () => {
        if (checkedRecords.length) {
            checkedRecords.forEach((value) => {
                console.log("user voucher id:", value);
                deleteUserVoucherGiftItem(value)
                    .then((data) => {
                    console.log("deleteUserVoucherGiftItem:", data);
                })
                    .catch((e) => {
                    console.warn(e);
                });
            });
            setDeleteModal(false);
        }
    };
    return (<div className="page-content">
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)}/>
      <DeleteModal show={deleteModalMulti} onDeleteClick={() => {
            deleteRecords();
            setDeleteModalMulti(false);
        }} onCloseClick={() => setDeleteModalMulti(false)}/>
      <Container fluid>
        <BreadCrumb title="예약(선물)관리" pageTitle="예약"/>
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">예약 (선물) 목록</h5>
                  <div className="flex-shrink-0">
                    <Button onClick={() => {
            printDiv("user-vouchers-table");
        }} color="soft">
                      <i className="ri-printer-line"></i>
                    </Button>
                    <span style={{ padding: "4px" }}></span>
                    <Button onClick={() => setDeleteModalMulti(true)} color="soft-danger">
                      <i className="ri-delete-bin-2-line"></i>
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody className="pt-0 px-2">
                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <div className="form-check form-switch mb-2">
                                                <input className="form-check-input" type="checkbox" id="show-expired-UserVoucherGiftList" checked={showExpired}
                                                    onChange={(e) => { const v = e.target.checked; setShowExpired(v); onRequestData(`${API_USER_VOUCHER_GIFTS}/?hide_expired=${v ? "" : "1"}`); }} />
                                                <label className="form-check-label" htmlFor="show-expired-UserVoucherGiftList">만료 포함 보기</label>
                                            </div>
                                            <ServerPaginatedTable tableQuery={expiredQuery} id="user-vouchers-table" url={API_USER_VOUCHER_GIFTS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[]}/>
                    </React.Fragment>
                  </div>
                </div>

                <Toaster position="top-center"/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>);
};
export default UserVoucherGiftList;
